export default {

    title: "Carregando...",

    responses: {
        "404": {
            title: "Ocorreu um erro",
            header: "Ocorreu um erro",
            message: "Token válido não encontrado. Seu token pode ter expirado."
        },
        "200": {
            title: "Sucesso",
            header: "Sucesso",
            message: "Sua solicitação foi processada com sucesso."
        },
        "200_tfalogin": {
            title: "Verificação de login",
            header: "@:views.tunnel.service.responses.200_tfalogin.title",
            message: "O login foi verificado."
        },
        "404_tfalogin": {
            title: "Verificação de login",
            header: "@:views.tunnel.service.responses.404_tfalogin.title",
            message: "Token válido não encontrado. Seu token pode ter expirado."
        },
        "200_tfaaddress": {
            title: "Verificação de endereço",
            header: "@:views.tunnel.service.responses.200_tfaaddress.title",
            message: "Obrigado por confirmar seu endereço. Agora você pode selecioná-lo como endereço de entrega ao fazer seu pedido."
        },
        "404_tfaaddress": {
            title: "Verificação de endereço",
            header: "@:views.tunnel.service.responses.404_tfaaddress.title",
            message: "Token válido não encontrado. Seu token pode ter expirado."
        },
        "201_delivery": {
            title: "Obrigado",
            header: "Obrigado",
            message: "Obrigado pela sua resposta."
        },
        "201_shipment_received": {
            title: "Obrigado",
            header: "Obrigado",
            message: "Obrigado pela sua resposta."
        },
        "400": {
            title: "Solicitação inválida. Ocorreu um erro.",
            header: "@:views.tunnel.service.responses.400.title",
            message: "Solicitação inválida. Ocorreu um erro."
        }
    }
}